// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609031804/js/" + chunkId + "." + {"44":"6f565f4c","225":"7893b70b","481":"508ab0e9","486":"27877726","770":"7632b1a7"}[chunkId] + ".0.8639651476908575.chunk.js";
};